<template>
  <div v-if="numPages" class="flex items-center justify-between">
    <span>{{ statusText }}</span>
    <q-btn-group rounded>
      <q-btn
        icon="fa fa-angle-left"
        color="white"
        text-color="primary"
        :disable="offset < perPage"
        @click="prevPage"
      />
      <q-btn
        icon="fa fa-angle-right"
        color="white"
        text-color="primary"
        :disable="(offset + perPage) >= total"
        @click="nextPage"
      />
    </q-btn-group>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PaginationMixin } from '@/mixins';

export default defineComponent({
  mixins: [PaginationMixin],
});
</script>
